import uly from "ulysses/base";
import "./prototype";

class WidgetManager {
    constructor()  {
        Object.assign(this, {
            required_fields : {
                "type" : "String",
                "description" : "String",
                "caption" : "String",
                "colour" : "String",
                "init" : "Function",
                "icon":function(s){
                    return String.isString(s) && s.startsWith("fa-");
                }
            },
            defaults_fields_settings : {
                "colour" : "default",
                //"init" : function(){return Promise.Deferred().resolve();}
            },
            registered_widgets: {}
    
        });
    }

    are_settings_valid(settings) {

        var not_valid = function(settings, key){
            console.error("Invalid", key?"key:":"", key?key:"", ".data:", settings);
            return false;
        };

        if (settings && Object.isObject(settings)) {
            for (var key in this.required_fields){
                if (!(key in settings))
                    return not_valid(settings, key);
                if (String.isString(this.required_fields[key])) {
                    if (!settings[key].typeof(uly.widgets.required_fields[key])){
                        return not_valid(settings, key);
                    }
                } else if (this.required_fields[key].typeof("Function")){
                    if (!this.required_fields[key](settings[key])){
                        return not_valid(settings, key);
                    }
                } else {
                    console.error("Unknown error", key, this.required_fields, settings);
                }
            }
        } else {
            return not_valid(settings);
        }
        return true;
    }

    register(settings) {
        let full_settings = Object.assign(Object.assign({}, this.default_field_settings), settings);
        let valid_data = this.are_settings_valid(full_settings);
        let exists = valid_data && (full_settings.type in this.registered_widgets);
        if (valid_data && !exists){
            let tmp = {};
            tmp[full_settings.type] = full_settings;
            this.registered_widgets[full_settings.type] = full_settings;
        }
        else{
            return console.error("Cannot register the widget with settings", settings, ". Widget alredy exist: ", exists, ".Widget data is valid: ", valid_data, "settings: ", settings);
        }
    }

    get_widget_settings(type) {
        if(type in this.registered_widgets)
            return this.registered_widgets[type];
        return null;
    }

    get_registered() {
        return this.registered_widgets;
    }

    get_visible_widgets() {
        return this.registered_widgets.mapProperties((key,widget) =>  [key, widget.hidden ? null : widget]);
    }
}

uly.widgets = new WidgetManager();
